import { useState } from 'react';
import { MdOutlineLock, MdOutlinePersonOutline } from 'react-icons/md';
import Mensagens from '../../utils/MensagemUtils';
import NotificacaoUtils from '../../utils/NotificacaoUtils';
import { TipoValidacao, ValidacaoUtils } from '../../utils/ValidacaoUtils';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import InputPadraoLogin from '../InputPadraoLogin/InputPadraoLogin';
import InputSenha from '../InputSenha/InputSenha';
import Logo from '../Logo/Logo';
import "./FormularioLogin.css";

const FormularioLogin = ({ aoLogar: handleLogin}) => {

    const timeoutLogin = 3000; 

    const [carregando, setCarregando] = useState(false);
    const [tentativasLogin, setTentativasLogin] = useState(0);
    const [horaUltimaTentativa, setHoraUltimaTentativa] = useState(new Date().getTime());
    
    const [login, setLogin] = useState("");
    const [senha, setSenha] = useState("");
    const [errors, setErrors] = useState({});

    const handleLoginClick = async () => {
      if(!validarFormulario(login, senha)) return;

      if (carregando) {
        NotificacaoUtils.aviso("Aguarde, processando...");
        return;
      }

      const horaAtual = new Date().getTime();

      if (tentativasLogin >= 3 && horaAtual - horaUltimaTentativa < timeoutLogin) {
        NotificacaoUtils.aviso("Limite de tentativas excedido. Tente novamente em " + Math.floor((timeoutLogin - (horaAtual - horaUltimaTentativa)) / 1000) + " segundos.");
        setCarregando(false);
        return;
      }

      setHoraUltimaTentativa(horaAtual);
      await handleLogin(login, senha);

      setCarregando(false);
      setTentativasLogin(tentativasLogin + 1);
    }

    const validarFormulario = (login, senha) => {
      const retornoValidacao = ValidacaoUtils.validateForm(
        { login, senha }, TipoValidacao.LOGIN
      );

      if (!retornoValidacao.success) {
        setErrors(retornoValidacao.errors);
        const mensagens = Object.values(retornoValidacao.errors).filter(Boolean).join('\n');
        if (mensagens) {
          NotificacaoUtils.aviso(mensagens);
        }
        return false;
      }

      return true;
    };

    const handlePressEnter = async (event) => {
      if (event.key === "Enter") await handleLoginClick();
    }

    return (
      <div className={"formulario-login"}>
        <Logo />

        <div className={"container-inputs"}>
          <InputPadraoLogin
            nome={"login"}
            placeholder={"Login"}
            onChange={setLogin}
            erro={errors.login}
            icone={<MdOutlinePersonOutline size={24} color="#888" />} 
            type="text"
            onKeyDown={handlePressEnter}
          />

          <InputSenha
            nome={"senha"}
            placeholder={"Senha"}
            titulo={"Senha"}
            onChange={setSenha}
            erro={errors.senha}
            onKeyDown={handlePressEnter}
            icone={<MdOutlineLock size={24} color="#888" />} 
          />
        </div>

        <div className={"container-esqueci-senha"}>
          <span
            className={"texto-esqueci-senha"}
            onClick={(e) => {
              NotificacaoUtils.emDesenvolvimento(
                Mensagens.FUNCIONALIDADE_EM_DESENVOLVIMENTO
              );
            }}
          >
            {Mensagens.ESQUECEU_SENHA}
          </span>
        </div>

        <BotaoPadrao
          classeCustom={"botao-padrao-login"}
          texto={"Entrar"}
          confirmar={true}
          aoClicar={handleLoginClick}
        />
      </div>
    );
}
 
export default FormularioLogin;